export const common = {
  // Navigation
  nav_home: 'ホーム',
  nav_about: '制作者',
  nav_portfolio: '作品',
  nav_gallery: 'ギャラリー',
  nav_products: '出品一覧',
  nav_testimonials: 'お客様の声',
  nav_process: '制作の流れ',
  nav_pricing: '料金',
  nav_faq: 'よくある質問',
  nav_contact: 'お問合せ',

  // Hero Section
  hero_title: '特別な瞬間を永遠に刻む',
  hero_subtitle: '高品質レーザー彫刻',
  hero_title_line1: '高品質な',
  hero_title_line2: 'レーザー彫刻で',
  hero_title_line3: '特別な瞬間を永遠に',
  hero_description: 'ステンレス製記念プレートから高級メタル名刺、オリジナル記念品まで。プロフェッショナルなレーザー彫刻技術で、あなたの大切な思い出や重要な瞬間を美しく刻み込みます。',
  hero_cta: '無料相談を始める',
  hero_secondary_cta: 'ポートフォリオを見る',

  // About Section
  about_title: '制作者について',
  about_subtitle: '情熱と創造性の融合',
  about_title_default: 'NEXUTHAについて',
  about_subtitle_default: '精密なレーザー彫刻で想いを形に',
  about_description_default: '私たちは最新のレーザー彫刻技術を駆使し、お客様の大切な思い出や特別な瞬間を美しく永続的な形で残すお手伝いをしています。',
  about_experience: '2年の経験',
  about_projects: '完成プロジェクト',
  about_satisfaction: '顧客満足度',
  about_feature_precision_title: 'Xtool F1 Ultra使用',
  about_feature_precision_desc: '最新のXtool F1 Ultraレーザー機器を使用し、精密で美しい彫刻を実現します。',
  about_feature_design_title: 'オリジナルデザイン',
  about_feature_design_desc: 'Procreateを使用した専門的な線画イラストで、独自のデザインを作成します。',
  about_feature_service_title: '丁寧な個人サービス',
  about_feature_service_desc: 'スタートアップとして、お客様一人一人に心のこもった丁寧なサービスを大切にしています。',
  about_years_experience: '2年の経験',
  about_image_alt: 'レーザー彫刻作業をする若い職人',
  about_satisfaction_label: 'お客様満足度',

  // Portfolio Section
  portfolio_title: 'ポートフォリオ',
  portfolio_subtitle: 'これまでの制作実績をご覧ください',
  portfolio_all: 'すべて',
  portfolio_plates: 'ステンレス記念プレート',
  portfolio_cards: '高級メタルカード',
  portfolio_custom: 'カスタムアイテム',
  portfolio_view_details: '詳細を見る',
  portfolio_item_memorial_plate: 'ステンレス記念プレート',
  portfolio_item_memorial_plate_desc: '高品質なステンレス素材を使用した永続的な記念プレート',
  portfolio_item_metal_card: '高級メタル名刺',
  portfolio_item_metal_card_desc: 'ビジネスシーンで印象的な高級メタル名刺',
  portfolio_item_custom_accessory: 'カスタム名刺',
  portfolio_item_custom_accessory_desc: 'お客様のご要望に合わせたオリジナルアクセサリー',
  portfolio_item_nameplate: 'ウォールナット表札',
  portfolio_item_nameplate_desc: '天然木の美しさと精密なレーザー彫刻を組み合わせた表札',
  portfolio_item_acrylic_keychain: 'アクリルキーホルダー（ブラック限定）',
  portfolio_item_acrylic_keychain_desc: 'ブラック限定アクリル素材に精密なレーザー彫刻を施した高品質キーホルダー',
  portfolio_leather_keychain_title: 'レザーキーホルダー',
  portfolio_leather_keychain_desc: '耐久性に優れたプレミアム品質のレザーキーホルダー',
  portfolio_acrylic_keychain_title: 'アクリルキーホルダー',
  portfolio_acrylic_keychain_desc: 'モダンなデザインの美しい透明アクリル製カスタムキーホルダー',
  portfolio_cta_text: 'あなたのアイデアを形にしませんか？',
  portfolio_cta_button: '無料相談を始める',
  portfolio_completed_works: '完成作品',
  portfolio_satisfaction_rate: '満足度',
  portfolio_years_experience: '年の経験',
  portfolio_cta_main_text: 'あなただけの特別なカスタム作品を作りませんか？',
  portfolio_cta_description: 'お客様の具体的なご要望に合わせて、世界に一つだけのオリジナル作品を制作いたします',
  portfolio_cta_consultation: '無料相談',
  portfolio_cta_phone: 'お電話',
  portfolio_note_title: '作品写真について',
  portfolio_note_desc: 'NEXUTHAでは、お客様の大切な思い出を一つひとつ丁寧に刻んでいます。多くの作品は個人のご注文に基づくオリジナルオーダーメイドのため、著作権等の関係で実際の完成写真を全て公開することは叶っておりません。掲載されている画像は、ご協力いただいたお客様の作品と、イメージ参考画像を含みます。あなただけの特別な作品を、ぜひご自身の手で体験してください。',

  // Process Section
  process_title: '制作工程',
  process_subtitle: '4つのステップであなたのビジョンを実現',
  process_step1_title: '相談・見積もり',
  process_step1_desc: 'お客様のご要望を丁寧にお聞きし、最適なプランをご提案します。',
  process_step2_title: 'デザイン作成',
  process_step2_desc: 'Procreateを使用してレーザー彫刻専用の線画イラストを作成します。',
  process_step3_title: 'レーザー彫刻',
  process_step3_desc: 'Xtool F1 Ultraを使用して丁寧に彫刻を行います。',
  process_step4_title: '完成・納品',
  process_step4_desc: '品質チェック後、大切にお届けいたします。',
  process_step: 'ステップ',
  process_timeline_title: '制作スケジュール',
  process_timeline_subtitle: '一般的な制作期間',
  process_timeline_consultation: '相談',
  process_timeline_consultation_time: '当日',
  process_timeline_design: 'デザイン',
  process_timeline_design_time: '2-3日',
  process_timeline_production: '制作',
  process_timeline_production_time: '3-5日',
  process_timeline_delivery: '納品',
  process_timeline_delivery_time: '1-2日',

  // Pricing Section
  pricing_title: '料金プラン',
  pricing_subtitle: 'ニーズに合わせた明確な料金体系',
  pricing_popular: '人気',
  pricing_price: '¥',
  pricing_from: '〜',
  pricing_per_piece: '/枚',
  pricing_for_50_pieces: '（50枚セット）',
  pricing_for_100_pieces: '（100枚セット）',
  pricing_choose_plan: 'このプランを選ぶ',
  pricing_contact_for_order: 'ご注文はこちら',
  pricing_web_discount: 'ホームページからのお問い合わせで10%割引',
  pricing_single_order: '1枚から注文可能',
  pricing_best_value: '最もお得',
  pricing_homepage_discount_banner: '🎉 ホームページからのご注文で10%割引！',
  pricing_simulator_title: '💰 料金シミュレーター',
  pricing_product_type: '商品タイプ',
  pricing_stainless_namecard: 'ステンレス名刺',
  pricing_memorial_plate: '記念プレート',
  pricing_size_label: 'サイズ（最大22cm×22cm）',
  pricing_size_10x10: '10cm × 10cm - ¥8,000',
  pricing_size_15x15: '15cm × 15cm - ¥12,000',
  pricing_size_20x20: '20cm × 20cm - ¥16,000',
  pricing_size_22x22: '22cm × 22cm - ¥20,000',
  pricing_quantity_label: '数量',
  pricing_quantity_1: '1枚 - ¥500',
  pricing_quantity_50: '50枚セット - ¥10,000',
  pricing_quantity_100: '100枚セット - ¥20,000',
  pricing_estimate_result: '見積もり結果',
  pricing_base_price: '基本料金',
  pricing_homepage_discount: 'ホームページ割引（10%OFF）',
  pricing_total_amount: '合計金額',
  pricing_view_testimonials: 'お客様の声を見る',
  pricing_professional_impression: 'プロフェッショナルな印象',
  pricing_single_order_available: '1枚から注文可能',
  pricing_per_piece_price: '1枚あたり',
  pricing_50_piece_set: '50枚セット',
  pricing_100_piece_set: '100枚セット',
  pricing_regular_price: '通常 ¥25,000',
  pricing_regular_price_100: '通常 ¥50,000',
  pricing_special_moments: '永遠に残る特別な瞬間',
  pricing_max_size: '最大22cm×22cm',
  pricing_contact_info: 'お問い合わせ',
  pricing_phone_inquiry: '電話でのお問い合わせ',
  pricing_email_inquiry: 'メールでのお問い合わせ',
  pricing_simulator_heading: '料金シミュレーター',
  pricing_product_select_label: '商品タイプを選択',
  pricing_size_select_label: 'サイズを選択',
  pricing_quantity_select_label: '数量を選択',
  pricing_faq_badge: 'よくある質問',
  pricing_faq_title: 'よくある質問',
  pricing_faq_subtitle: '料金に関するよくある質問',
  pricing_faq_question_1: '料金はどのくらいかかりますか？',
  pricing_faq_answer_1: 'ステンレス名刺は1枚500円から、記念プレートは8,000円からとなります。ホームページからのご注文で10%割引が適用されます。',
  pricing_faq_question_2: '見積もりは無料ですか？',
  pricing_faq_answer_2: 'はい、お見積もりは完全無料です。ホームページの見積もりフォームまたはお電話でお気軽にお問い合わせください。見積書の作成も承っております。',
  pricing_faq_question_3: '支払い方法は何がありますか？',
  pricing_faq_answer_3: '銀行振込でのお支払いとなります。ご入金確認後、制作を開始させていただきます。',
  pricing_faq_question_4: 'キャンセル料はかかりますか？',
  pricing_faq_answer_4: '制作開始前のキャンセルは無料です。制作開始後は進捗状況によってキャンセル料が発生する場合があります。',
  pricing_faq_question_5: '納期はどのくらいですか？',
  pricing_faq_answer_5: '通常5-7営業日でお届けします。お急ぎの場合は3日以内の特急対応も可能です（+2,000円）。',
  pricing_faq_question_6: '配送料はかかりますか？',
  pricing_faq_answer_6: '配送先によって適正価格にてお調べしてご案内いたします。お見積もり時に配送料も含めた総額をご提示いたします。',
  pricing_faq_question_7: 'デザインの修正は可能ですか？',
  pricing_faq_answer_7: '初回デザイン提案後、2回まで無料で修正いたします。3回目以降は1回につき1,000円の修正料が発生します。',
  pricing_faq_question_8: 'その他のご質問は？',
  pricing_faq_answer_8: 'FAQページをご覧ください',

  // Stainless Steel Business Cards
  pricing_stainless_cards_title: 'ステンレス名刺',
  pricing_stainless_title: '単品注文',
  pricing_stainless_description: '1枚から注文可能',
  pricing_stainless_feature1: '高級ステンレス素材',
  pricing_stainless_feature2: 'レーザー彫刻加工',
  pricing_stainless_feature3: '耐久性抜群',
  pricing_10_pieces_set: '10枚セット',
  pricing_50_pieces_set: '50枚セット',
  pricing_100_pieces_set: '100枚セット',
  pricing_15_percent_off: '15%OFF',
  pricing_25_percent_off: '25%OFF',
  pricing_30_percent_off: '30%OFF',

  // Memorial Plates
  pricing_memorial_plates_title: '記念プレート',
  pricing_memorial_small_desc: '小型の記念プレート',
  pricing_memorial_large_desc: '大型の記念プレート',
  pricing_memorial_feature1: 'カスタムデザイン対応',
  pricing_memorial_feature2: '記念品に最適',
  pricing_memorial_feature3: '永続的な品質',

  // FAQ in Pricing
  faq_pricing_question_1: '料金はどのくらいかかりますか？',
  faq_pricing_answer_1: 'ステンレス名刺は1枚500円から、記念プレートは8,000円からとなります。ホームページからのご注文で10%割引が適用されます。',
  faq_pricing_question_2: '見積もりは無料ですか？',
  faq_pricing_answer_2: 'はい、お見積もりは完全無料です。ホームページの見積もりフォームまたはお電話でお気軽にお問い合わせください。見積書の作成も承っております。',
  faq_pricing_question_3: '支払い方法は何がありますか？',
  faq_pricing_answer_3: '銀行振込でのお支払いとなります。ご入金確認後、制作を開始させていただきます。',
  faq_pricing_question_4: 'キャンセル料はかかりますか？',
  faq_pricing_answer_4: '制作開始前のキャンセルは無料です。制作開始後は進捗状況によってキャンセル料が発生する場合があります。',
  faq_pricing_question_5: '納期はどのくらいですか？',
  faq_pricing_answer_5: '通常5-7営業日でお届けします。お急ぎの場合は3日以内の特急対応も可能です（+2,000円）。',
  faq_pricing_question_6: '配送料はかかりますか？',
  faq_pricing_answer_6: '配送先によって適正価格にてお調べしてご案内いたします。お見積もり時に配送料も含めた総額をご提示いたします。',
  faq_pricing_question_7: 'デザインの修正は可能ですか？',
  faq_pricing_answer_7: '初回デザイン提案後、2回まで無料で修正いたします。3回目以降は1回につき1,000円の修正料が発生します。',
  faq_pricing_question_8: 'その他のご質問は？',
  faq_pricing_answer_8: 'FAQページをご覧ください',

  // Custom Design
  pricing_custom_design_title: 'カスタムデザイン料',
  pricing_custom_design_desc: 'オリジナルデザインの作成費用',
  pricing_custom_consultation: 'デザイン相談',

  // Size Limitation
  pricing_size_limitation_title: '制作可能サイズ',
  pricing_size_limitation_desc: '最大22cm × 22cmまでの範囲内で制作いたします',

  // Additional Services
  pricing_additional_title: 'サービス保証',
  pricing_web_discount_title: 'ホームページ割引',
  pricing_web_discount_desc: 'ホームページからのお問い合わせで10%OFF',
  pricing_guarantee_title: '品質保証',
  pricing_guarantee_desc: '30日間品質保証',
  pricing_shipping_title: '送料無料',
  pricing_shipping_desc: '全国送料無料',
  pricing_support_title: 'アフターサポート',
  pricing_support_desc: '制作後も安心のサポート',

  // Contact Section
  contact_title: 'お問い合わせ',
  contact_description: '制作のご相談・お見積もりは無料です。お気軽にお問い合わせください。',
  contact_info_title: 'お気軽にお問い合わせください',
  contact_info_description: 'スタートアップとして、お客様一人一人に心のこもった丁寧なサービスを心がけています。ご質問、ご相談、お見積もりなど、お気軽にお問い合わせください。',
  contact_info_email_title: 'メール',
  contact_info_email_desc: '24時間受付、翌営業日回答',
  contact_info_phone_title: '電話',
  contact_info_phone_desc: '営業時間内対応',
  contact_info_hours_title: '営業時間',
  contact_info_hours_content: '9:00 - 18:00',
  contact_info_hours_desc: '月〜土（日祝休み）',
  contact_info_online_title: 'オンライン専門',
  contact_info_online_content: '全国対応',
  contact_info_online_desc: 'オンライン注文のみ',
  contact_form_title: '詳細お問い合わせ',
  contact_name: 'お名前',
  contact_email: 'メールアドレス',
  contact_phone: '電話番号',
  contact_material: 'ご希望素材',
  contact_budget: 'ご予算',
  contact_category: '制作カテゴリー',
  contact_deadline: 'ご希望納期',
  contact_details: '詳細なご要望・ご質問',
  contact_details_placeholder: '制作したいアイテム、デザインのご希望、その他ご質問などをお聞かせください（500文字以内）',
  contact_character_count: '文字',
  contact_submit: 'お問い合わせを送信',
  contact_submitting: '送信中...',
  contact_select_option: '選択してください',
  contact_material_walnut: 'ウォールナット材',
  contact_material_oak: 'オーク材',
  contact_material_stainless: 'ステンレス',
  contact_material_other: 'その他・相談',
  contact_budget_under_10k: '1万円未満',
  contact_budget_10k_20k: '1万円〜2万円',
  contact_budget_20k_50k: '2万円〜5万円',
  contact_budget_over_50k: '5万円以上',
  contact_budget_consultation: '要相談',
  contact_category_nameplate: '表札',
  contact_category_memorial: '記念品',
  contact_category_business_card: '名刺',
  contact_category_accessory: 'アクセサリー',
  contact_category_architectural: '建築関連',
  contact_category_other: 'その他',
  contact_success_message: 'お問い合わせを受け付けました。24時間以内にご連絡いたします。',
  contact_error_message: '送信に失敗しました。再度お試しください。',
  contact_line_badge: 'NEW',
  contact_line_title: 'LINE公式アカウント開設しました！',
  contact_line_desc: '画像共有が簡単！デザイン相談はLINEが便利です 📸',
  contact_line_add: '友だち追加',

  // Footer
  footer_company: 'NEXUTHA',
  footer_description: '名古屋市港区の個人レーザー彫刻工房。木材やステンレスにあなたの想いを刻み、一つ一つ心を込めて丁寧に制作しています。',
  footer_quick_links: 'クイックリンク',
  footer_links: 'リンク',
  footer_services: 'サービス',
  footer_contact_info: 'お問い合わせ',
  footer_made_with: 'Made with NEXUTHA',
  footer_copyright: '© 2026 NEXUTHA. All rights reserved.',
  footer_service_nameplate: '記念プレート',
  footer_service_stainless: 'ステンレス名刺',
  footer_service_business_card: '木製表札',
  footer_service_memorial: 'レザーキーホルダー',
  footer_service_accessory: 'アクリルキーホルダー（ブラック限定）',
  footer_service_architectural: 'カスタムオーダー',
  footer_online_only: 'オンライン専門',
  footer_hours: '9:00-18:00（月〜土）',
  footer_privacy: 'プライバシーポリシー',
  footer_terms: '利用規約',
  footer_commerce_law: '特定商取引法',

  // Legal pages
  legal_privacy_hero_title: 'プライバシーポリシー',
  legal_privacy_hero_subtitle: 'NEXUTHA',
  legal_privacy_hero_desc: 'お客様の個人情報の取り扱いについて',
  legal_privacy_section1_title: '1. 個人情報の定義',
  legal_privacy_section1_desc: '「個人情報」とは、生存する個人に関する情報であって、\n当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレス、その他の記述等により\n特定の個人を識別することができるものをいいます。',
  legal_privacy_section2_title: '2. 個人情報の収集・利用目的',
  legal_privacy_section2_desc: '当社は、以下の目的のため、適正な手段により個人情報を収集し、利用いたします。',
  legal_privacy_purpose1: 'お客様からのお問い合わせへの対応',
  legal_privacy_purpose2: 'ご注文商品の制作、発送、およびアフターサービス',
  legal_privacy_purpose3: '見積もりの作成およびご連絡',
  legal_privacy_purpose4: 'メールマガジン等の配信（希望されたお客様のみ）',
  legal_privacy_purpose5: '当社サービスの品質向上および統計分析',
  legal_privacy_section3_title: '3. 個人情報の管理',
  legal_privacy_section3_desc: '当社は、お客様の個人情報を正確かつ最新の状態に保ちます。\n不正アクセス、紛失、破損、改ざん、漏洩などを防止するため、\nセキュリティシステムの維持・管理と従業員への教育を徹底し、\n安全管理に努めます。',
  legal_privacy_section4_title: '4. 個人情報の第三者提供',
  legal_privacy_section4_desc: '当社は、以下の場合を除き、お客様の同意なく第三者に個人情報を提供することはありません。',
  legal_privacy_provide1: '法令に基づく場合',
  legal_privacy_provide2: '人の生命、身体または財産の保護のために必要がある場合',
  legal_privacy_provide3: '公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合',
  legal_privacy_provide4: '国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合',
  legal_privacy_section5_title: '5. Cookieの使用について',
  legal_privacy_section5_desc: '当社のウェブサイトでは、サイトの利便性向上および利用状況の分析のため、Cookieを使用する場合があります。\nCookieは個人を特定する情報を含みません。\nブラウザの設定でCookieを無効にすることも可能です。',
  legal_privacy_section6_title: '6. アクセス解析ツール',
  legal_privacy_section6_desc: '当サイトでは、サービス向上のためGoogleアナリティクスを利用しています。\nGoogleアナリティクスはCookieを使用して、個人を特定することなくアクセス情報を収集します。',
  legal_privacy_section7_title: '7. お問い合わせ先',
  legal_privacy_section7_desc: '個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。',
  legal_privacy_contact_email: 'nexutha.official@gmail.com',
  legal_privacy_contact_hours: '受付時間: 9:00〜18:00（月〜土）',
  legal_privacy_last_updated: '最終更新日: 2026年5月1日',

  legal_terms_hero_title: '利用規約',
  legal_terms_hero_subtitle: 'NEXUTHA',
  legal_terms_hero_desc: '当サービスのご利用にあたっての規定',
  legal_terms_section1_title: '第1条（適用）',
  legal_terms_section1_desc: '本規約は、NEXUTHA（以下「当社」）が提供するレーザー彫刻サービス（以下「本サービス」）の利用に関する条件を定めるものです。\nお客様は、本サービスを利用することにより、本規約に同意したものとみなされます。',
  legal_terms_section2_title: '第2条（注文・契約）',
  legal_terms_section2_desc: 'お客様が本サービスを通じて商品を注文した場合、注文内容を確認の上、当社より注文確認メールを送信いたします。\n注文確認メールの送信をもって契約が成立するものとします。',
  legal_terms_section3_title: '第3条（支払い方法）',
  legal_terms_section3_desc: '支払い方法は銀行振込のみとなります。ご入金の確認後、制作を開始いたします。振込手数料はお客様のご負担となります。',
  legal_terms_section4_title: '第4条（納品・配送）',
  legal_terms_section4_desc: 'ヤマト運輸にて発送いたします。\n配送中の破損・紛失については、当社の責に帰すべき事由がある場合を除き、当社は責任を負いません。',
  legal_terms_section5_title: '第5条（キャンセル・返品）',
  legal_terms_section5_desc: '制作開始前のキャンセルは無料です。制作開始後は、進捗状況に応じてキャンセル料が発生する場合があります。お客様都合による返品・交換は、商品に明らかな不具合がある場合を除き、原則お受けできません。',
  legal_terms_section6_title: '第6条（著作権・所有権）',
  legal_terms_section6_desc: 'お客様が提供したデザイン・データの著作権はお客様に帰属します。\nただし、制作過程で当社が作成したオリジナルデザインの著作権は当社に帰属します。',
  legal_terms_section7_title: '第7条（禁止事項）',
  legal_terms_section7_desc: 'お客様は、本サービスの利用にあたり、以下の行為を行ってはなりません。',
  legal_terms_prohibit1: '法令または公序良俗に違反する行為',
  legal_terms_prohibit2: '他のお客様または第三者の権利を侵害する行為',
  legal_terms_prohibit3: '本サービスの運営を妨害する行為',
  legal_terms_prohibit4: '不正アクセスまたはその試み',
  legal_terms_section8_title: '第8条（免責事項）',
  legal_terms_section8_desc: '当社は、本サービスに関して、お客様または第三者が被った損害について、\n当社の故意または重過失による場合を除き、一切の責任を負いません。',
  legal_terms_section9_title: '第9条（規約の変更）',
  legal_terms_section9_desc: '当社は、必要と認めた場合には、お客様に通知することなく本規約を変更することができるものとします。\n変更後の規約は、当社ウェブサイトに掲示された時点から効力を生じます。',
  legal_terms_section10_title: '第10条（準拠法・管轄裁判所）',
  legal_terms_section10_desc: '本規約の解釈にあたっては、日本法を準拠法とします。\n本サービスに関して紛争が生じた場合、名古屋地方裁判所を第一審の専属的合意管轄裁判所とします。',
  legal_terms_last_updated: '最終更新日: 2026年5月1日',

  legal_commerce_hero_title: '特定商取引法に基づく表記',
  legal_commerce_hero_subtitle: 'NEXUTHA',
  legal_commerce_hero_desc: '特定商取引法に基づく事業者情報および取引条件',
  legal_commerce_section1_title: '販売事業者',
  legal_commerce_section1_desc: 'NEXUTHA（ネクスス）',
  legal_commerce_section2_title: '代表者',
  legal_commerce_section2_desc: '山下 泰秀',
  legal_commerce_section3_title: '所在地',
  legal_commerce_section3_desc: '愛知県名古屋市港区',
  legal_commerce_section4_title: 'お問い合わせ先',
  legal_commerce_section4_desc: 'メール: nexutha.official@gmail.com\n電話: 080-2668-1795（受付時間: 9:00〜18:00、月〜土）',
  legal_commerce_section5_title: '販売価格',
  legal_commerce_section5_desc: '各商品ページに記載の価格に基づきます。\n消費税は価格に含まれています（税込表示）。',
  legal_commerce_section6_title: '支払い方法',
  legal_commerce_section6_desc: '銀行振込（振込手数料はお客様負担）',
  legal_commerce_section7_title: '商品の引渡時期',
  legal_commerce_section7_desc: 'ご入金確認後、通常5〜7営業日で制作・発送いたします。\n特急対応の場合は3営業日以内（+2,000円）。',
  legal_commerce_section8_title: '返品・キャンセル',
  legal_commerce_section8_desc: '制作開始前のキャンセルは無料です。\n制作開始後は進捗状況に応じてキャンセル料が発生します。\nお客様都合による返品はお受けできません。',
  legal_commerce_section9_title: '配送方法・送料',
  legal_commerce_section9_desc: 'ヤマト運輸にて発送いたします。\n送料は配送先によって異なり、お見積もり時にご案内いたします。',
  legal_commerce_section10_title: '動作環境',
  legal_commerce_section10_desc: '本ウェブサイトは、以下のブラウザの最新版に対応しています。\nGoogle Chrome / Safari / Firefox / Microsoft Edge',
  legal_commerce_last_updated: '最終更新日: 2026年5月1日',
  legal_commerce_section11_title: '法人対応について',
  legal_commerce_section11_desc: '法人様からのご注文も承っております。\n個人のお客様と同様に、お気軽にご相談ください。\n見積書の発行も可能です。',
  legal_commerce_section12_title: '適格請求書等保存方式（インボイス制度）について',
  legal_commerce_section12_desc: 'ただいま、適格請求書等保存方式（インボイス制度）に基づく\n適格請求書発行事業者の登録はおこなっておりません。\nインボイス対応が必要な場合は別途ご相談ください。\nそれでも問題ない場合は、その旨ご了承の上、ご注文ください。',
  footer_line_label: 'LINE公式アカウント',

  // Products Page
  products_coming_soon_badge: '準備中 — 随時更新中',
  products_hero_title: '出品一覧',
  products_hero_desc: '現在出品準備中です。商品が整い次第、随時掲載していきます。',
  products_preparing_title: '出品準備中',
  products_preparing_desc: '現在、出品商品を準備しています。完成次第、こちらに掲載いたします。ご希望の商品やご相談がございましたら、LINEまたはお問い合わせフォームからお気軽にご連絡ください。',
  products_line_cta: 'LINEで問い合わせる',
  products_notice_title: '現在、出品ページを準備中です',
  products_notice_desc: '掲載商品は随時追加・更新していきます。気になる商品や「こんなものが欲しい」というご要望は、LINEまたはお問い合わせフォームからお気軽にご連絡ください。',
  products_view_detail: '詳細を見る',
  products_inquiry_btn: '問い合わせる',
  products_soldout: '受付終了',
  products_price_range: '価格帯',
  products_price_note: '※ 詳細はお問い合わせください',
  products_line_inquiry: 'LINEで問い合わせる',
  products_empty: '該当する商品がありません',
  products_inquiry_badge: 'お問い合わせ',
  products_inquiry_title: '気になる商品はお気軽にご連絡を',
  products_inquiry_desc: '「出品一覧を見ました。この商品は販売可能ですか？」など、お気軽にご連絡ください。LINEでの画像共有も大歓迎です。',
  products_inquiry_line_title: 'LINE公式アカウント',
  products_inquiry_line_desc: '画像共有・スピード対応',
  products_inquiry_form_title: 'お問い合わせフォーム',
  products_inquiry_form_desc: '24時間受付・翌営業日回答',
  products_inquiry_modal_badge: 'お問い合わせ',
  products_inquiry_modal_title: '商品についてのお問い合わせ',
  products_inquiry_modal_product: '対象商品',
  products_inquiry_name: 'お名前',
  products_inquiry_name_placeholder: '山田 太郎',
  products_inquiry_email: 'メールアドレス',
  products_inquiry_message: 'メッセージ',
  products_inquiry_message_placeholder: '例：出品一覧を見ました。ステンレス名刺（スタンダード）は現在購入可能でしょうか？50枚ほど希望しています。',
  products_inquiry_submit: '送信する',
  products_inquiry_submitting: '送信中...',
  products_inquiry_error: '送信に失敗しました。再度お試しください。',
  products_inquiry_privacy_note: '送信いただいた情報は制作・返信以外の目的には使用しません。',
  products_inquiry_success_title: 'お問い合わせを受け付けました',
  products_inquiry_success_desc: '24時間以内にご連絡いたします。お急ぎの場合はLINEからもご連絡いただけます。',

  // Gallery Page
  gallery_badge_text: '作品ギャラリー',
  gallery_title: '制作実績ギャラリー',
  gallery_description: 'これまでに制作した様々な作品をご覧いただけます。レーザー彫刻の技術と創造性が生み出す美しい作品の数々をお楽しみください。',
  gallery_upload_button: '画像をアップロード',
  gallery_uploading: 'アップロード中',
  gallery_uploading_progress: 'ファイルを処理しています...',
  gallery_supported_formats: 'JPG, PNG対応',
  gallery_max_size: '最大10MB',
  gallery_multiple_support: '複数選択可能',
  gallery_file_size_error: 'ファイル「{{fileName}}」のサイズが大きすぎます（最大10MB）',
  gallery_file_type_error: 'ファイル「{{fileName}}」は画像ファイルではありません',
  gallery_uploaded_work_description: 'アップロードされた作品',
  gallery_material_digital: 'デジタル',
  gallery_technique_upload: 'アップロード',
  gallery_delete_confirmation: 'この画像を削除してもよろしいですか？',
  gallery_download_failed: 'ダウンロードに失敗しました',
  gallery_filter_all: '全て',
  gallery_filter_plates: 'プレート',
  gallery_filter_cards: '名刺',
  gallery_filter_accessories: 'アクセサリー',
  gallery_filter_custom: 'カスタム',
  gallery_search_placeholder: '作品を検索...',
  gallery_sort_date: '日付順',
  gallery_sort_title: 'タイトル順',
  gallery_sort_category: 'カテゴリー順',
  gallery_sort_label: '並び替え',
  gallery_stats_total_works: '総作品数',
  gallery_stats_my_works: 'マイ作品',
  gallery_stats_displaying: '表示中',
  gallery_stats_categories: 'カテゴリー数',
  gallery_stats_featured: '注目作品',
  gallery_my_work_badge: 'マイ作品',
  gallery_featured_work: '注目作品',
  gallery_category_custom: 'カスタム',
  gallery_no_photos_title: '作品がありません',
  gallery_no_photos_description: 'まだ作品がアップロードされていません。管理者画面から作品を追加してください。',
  gallery_download: 'ダウンロード',
  gallery_delete: '削除',
  gallery_detail_material: '素材',
  gallery_detail_size: 'サイズ',
  gallery_detail_technique: '技法',
  gallery_upload_date: 'アップロード日',
  gallery_admin_access: '管理者画面',
  gallery_view_only: '閲覧専用',
  gallery_download_available: 'ダウンロード可能',
  gallery_search_filter: '検索・フィルター',
  gallery_breadcrumb_home: 'ホーム',
  gallery_breadcrumb_gallery: 'ギャラリー',
  gallery_hero_title: 'レーザー彫刻',
  gallery_hero_subtitle: '作品ギャラリー',
  gallery_hero_subtitle2: 'NEXUTHA',
  gallery_hero_description: 'これまでに制作した様々な作品をご覧いただけます。レーザー彫刻の技術と創造性が生み出す美しい作品の数々をお楽しみください。',
  gallery_uploaded_work: 'アップロード作品',
  gallery_download_started: 'ダウンロードを開始しました！デバイスのダウンロードフォルダをご確認ください。',
  gallery_download_fallback: '直接ダウンロードに失敗しました。新しいタブで画像を開きました。右クリックして「名前を付けて保存」を選択してください。',
  gallery_download_error: 'ダウンロードに失敗しました。画像データが破損している可能性があります。管理者にお問い合わせください。',
  gallery_copyright_notice: 'オーダーメイド作品について',
  gallery_copyright_notice_desc: 'NEXUTHAでは、お客様の大切な思い出を一つひとつ丁寧に刻んでいます。多くの作品は個人のご注文に基づくオリジナルオーダーメイドのため、著作権等の関係で実際の完成写真を全て公開することは叶っておりません。掲載されている画像は、ご協力いただいたお客様の作品と、イメージ参考画像を含みます。あなただけの特別な作品を、ぜひご自身の手で体験してください。',

  // Admin translations
  admin_login_title: '管理者ログイン',
  admin_login_description: 'ギャラリー管理にはパスワードが必要です',
  admin_password_label: 'パスワード',
  admin_password_placeholder: 'パスワードを入力してください',
  admin_login_button: 'ログイン',
  admin_back_to_gallery: 'ギャラリーに戻る',
  admin_invalid_password: 'パスワードが正しくありません',
  admin_panel_badge: '管理者パネル',
  admin_panel_title: 'ギャラリー管理',
  admin_panel_description: '作品のアップロード、編集、削除を行います',
  admin_view_gallery: 'ギャラリーを見る',
  admin_logout: 'ログアウト',
  admin_upload_section_title: '新しい作品をアップロード',
  admin_upload_title: 'ファイルを選択',
  admin_upload_description: 'JPG、PNG画像ファイルをアップロード（最大10MB）',
  admin_select_files: 'ファイルを選択',
  admin_total_photos: '総作品数',
  admin_today_uploads: '今日のアップロード',
  admin_total_size: '総サイズ',
  admin_manage_photos: '作品を管理',
  admin_no_photos: 'まだ作品がありません',
  admin_view_details: '詳細を見る',
  admin_edit: '編集',
  admin_delete: '削除',
  admin_upload_date: 'アップロード日',
  admin_category: 'カテゴリー',
  admin_size: 'サイズ',
  admin_material: '材質',
  admin_edit_photo: '作品を編集',
  admin_photo_title: 'タイトル',
  admin_photo_description: '説明',
  admin_photo_category: 'カテゴリー',
  admin_photo_material: '材質',
  admin_photo_technique: '技法',
  admin_cancel: 'キャンセル',
  admin_save_changes: '変更を保存',
  admin_supported_formats: 'JPG、PNG対応',
  admin_max_size: '最大10MB',
  admin_multiple_support: '複数選択可能',

  // Testimonials Page
  testimonials_title: 'お客様の声',
  testimonials_subtitle: '実際にご利用いただいたお客様からの声をご紹介します',
  testimonials_badge_text: 'お客様の声',
  testimonials_like_button: 'いいね',
  testimonials_already_liked: 'いいね済み',
  testimonials_nexutha_reply: 'NEXUTHAからの返信',
  testimonials_breadcrumb_home: 'ホーム',
  testimonials_breadcrumb_page: 'お客様の声',
  testimonials_hero_title: 'お客様の声',
  testimonials_hero_subtitle: 'NEXUTHA',
  testimonials_hero_subtitle2: 'NEXUTHA',
  testimonials_hero_description: 'お客様からよくいただくご質問にお答えします',
  testimonials_stats_title: 'お客様満足度',
  testimonials_total_reviews: '総レビュー数',
  testimonials_average_rating: '平均評価',
  testimonials_satisfaction_rate: '満足度',
  testimonials_repeat_customers: 'リピート率',

  // お客様の声（時系列順）
  testimonials_customer_23_name: 'H.K.様',
  testimonials_customer_23_age: '40代',
  testimonials_customer_23_gender: '男性',
  testimonials_customer_23_location: '愛知県',
  testimonials_customer_23_product: 'ステンレスグラス レーザー加工（100個）',
  testimonials_customer_23_comment: '3月もまたお願いしました。今回も100個ほどのステンレスグラスに会社のロゴを入れていただきました。円柱への加工は難しいと聞いていましたが、仕上がりはとても綺麗で、スタッフにも好評でした。毎回丁寧に対応していただけるので、また次もお願いしたいと思っています。',
  testimonials_customer_23_date: '2026-03-18',
  testimonials_customer_23_reply: 'H.K.様、今回もご依頼いただきありがとうございました。円柱面へのロゴ加工は設置の調整が難しく、毎回試行錯誤しながら取り組んでいます。それだけに、綺麗に仕上がったときの達成感はひとしおです。スタッフの皆様にも喜んでいただけたとのこと、とても嬉しいです。またいつでもご連絡ください。（山下）',

  testimonials_customer_22_name: 'M.T.様',
  testimonials_customer_22_age: '30代',
  testimonials_customer_22_gender: '男性',
  testimonials_customer_22_location: '愛知県',
  testimonials_customer_22_product: 'オリジナルキーホルダー（ステンレスプレート×10個）',
  testimonials_customer_22_comment: 'デザインの段階から一緒に考えていただき、思っていた以上のものができました。ステンレスプレートとキーホルダーの組み合わせで、シンプルながらしっかりとした仕上がりです。自分のアイデアが形になる過程が楽しく、良い経験になりました。',
  testimonials_customer_22_date: '2026-03-22',
  testimonials_customer_22_reply: 'M.T.様、デザインからご一緒できて、こちらも楽しい制作でした。「こういう雰囲気にしたい」というイメージを少しずつ形にしていく作業は、毎回新しい発見があります。気に入っていただけて何よりです。またお気軽にご相談ください。（山下）',

  testimonials_customer_21_name: 'K.様',
  testimonials_customer_21_age: '50代',
  testimonials_customer_21_gender: '男性',
  testimonials_customer_21_location: '愛知県',
  testimonials_customer_21_product: '高級木製ハンガー 名前刻印',
  testimonials_customer_21_comment: 'プレゼント用に、木製ハンガーへ名前と画数をあしらったデザインで刻印をお願いしました。受け取った方にもとても喜んでいただけて、贈り物として選んで正解でした。上品な仕上がりで、こちらも満足しています。',
  testimonials_customer_21_date: '2026-03-28',
  testimonials_customer_21_reply: 'K.様、プレゼントとしてお選びいただきありがとうございました。名前の画数をデザインに取り入れるご提案、制作していてとても楽しかったです。受け取られた方にも喜んでいただけたとのこと、こちらも嬉しくなりました。またいつでもどうぞ。（山下）',

  testimonials_customer_19_name: '大嶋様',
  testimonials_customer_19_age: '50代',
  testimonials_customer_19_gender: '男性',
  testimonials_customer_19_location: '愛知県',
  testimonials_customer_19_product: '銀行役員用カスタムネームプレート',
  testimonials_customer_19_comment: '最初は万年筆への彫刻をお願いしようと思っていましたが、長谷川様から万年筆への彫刻は高価な品を損なうリスクがあるとのご指摘を受け、一度はお見送りすることにしました。その後、ネームプレートという新しいご提案をいただき、正直諦めかけたところでしたが、期待以上の仕上がりで大変満足しております。プロフェッショナルな対応に感謝しています。',
  testimonials_customer_19_date: '2026-01-06',
  testimonials_customer_19_reply: '大嶋様、この度はカスタムオーダーをご依頼いただきありがとうございました。一度はお見送りとなりましたが、お客様の大切なお品物を守りつつ、ご要望を実現する方法を考え、ネームプレートをご提案させていただきました。「諦めかけた」というお言葉をいただき、ご提案させていただいて本当によかったと心から思います。今後ともどうぞよろしくお願いいたします。（長谷川）',
  testimonials_customer_20_name: '(・∀・) 様',
  testimonials_customer_20_age: '30代',
  testimonials_customer_20_gender: '男性',
  testimonials_customer_20_location: '',
  testimonials_customer_20_product: '真鍮製カスタムピン・スカルフィッシュ',
  testimonials_customer_20_comment: 'SNSで一目惚れしたスカルフィッシュを、実用性抜群のピンバッジにカスタムしていただきました。\n\n手元に届いて驚いたのは、その圧倒的な安心感です。裏面の接合部はレジンで丁寧に補強されており、ガタつきが一切ありません。デザインの良さを損なわず、ハードな使用にも耐えうる『道具としての強さ』を感じます。\n\nさらに、サービスで頂いた本革キーホルダーもコバまで美しく磨き上げられており、山下さんの徹底した仕事ぶりに感動しました。一生モノの相棒として大切にします。',
  testimonials_customer_20_date: '2026-02-20',
  testimonials_customer_20_reply: '(・∀・)様、この度はNEXUTHAの第1号作品となるカスタムオーダーをご依頼いただき、誠にありがとうございました。\n\n今回の制作では、デザインの美しさはそのままに、実用シーンでの耐久性を最優先に考えました。裏面の接合部には、ハンダ付けの補強としてレジンを5層にわたって充填し、指で力を加えてもビクともしない剛性を確保しています。表面からは見えない部分ですが、長く愛用していただくための「NEXUTHA基準」の仕上がりです。\n\nセットのレザーキーホルダーと共に、真鍮と革のタフな質感を楽しんでいただければ幸いです。また何かございましたら、いつでもご連絡ください！（山下）',
  testimonials_customer_18_name: '池田様',
  testimonials_customer_18_age: '20代',
  testimonials_customer_18_gender: '男性',
  testimonials_customer_18_location: '茨城県',
  testimonials_customer_18_product: '就職内定記念プレート',
  testimonials_customer_18_comment: '第一志望の会社に内定をいただいた記念に作成しました。会社名と内定日が刻まれており、新社会人としての決意を新たにしています。',
  testimonials_customer_18_date: '2025-01-08',
  testimonials_customer_18_reply: '池田様、この度は内定おめでとうございます！人生の新たなスタートを記念するプレートを作らせていただき光栄です。新社会人としてのご活躍を心よりお祈りしております。（山下）',
  testimonials_customer_17_name: '森様',
  testimonials_customer_17_age: '30代',
  testimonials_customer_17_gender: '女性',
  testimonials_customer_17_location: '栃木県',
  testimonials_customer_17_product: '演劇公演記念プレート',
  testimonials_customer_17_comment: '演劇の公演記念に作成しました。作品名と公演日が美しく彫刻されており、劇団メンバーみんなで喜んでいます。',
  testimonials_customer_17_date: '2025-01-25',
  testimonials_customer_17_reply: '森様、公演の成功おめでとうございます。劇団の皆様にお喜びいただけて本当に嬉しいです。演劇への情熱を形にできたこと、制作者として誇りに思います。（長谷川）',
  testimonials_customer_16_name: '清水様',
  testimonials_customer_16_age: '50代',
  testimonials_customer_16_gender: '男性',
  testimonials_customer_16_location: '群馬県',
  testimonials_customer_16_product: 'ダーツ大会優勝記念プレート',
  testimonials_customer_16_comment: 'ダーツ大会で優勝した記念に作成していただきました。大会名と優勝日が刻まれており、自宅に大切に飾っています。',
  testimonials_customer_16_date: '2025-02-18',
  testimonials_customer_16_reply: '清水様、優勝おめでとうございます！努力の結晶を形にするお手伝いができて光栄です。これからも大会でのご活躍を楽しみにしております。（山下）',
  testimonials_customer_15_name: '斎藤様',
  testimonials_customer_15_age: '40代',
  testimonials_customer_15_gender: '女性',
  testimonials_customer_15_location: '新潟県',
  testimonials_customer_15_product: '桜祭り記念プレート',
  testimonials_customer_15_comment: '地域の桜祭りの記念に作成しました。祭り名と開催年が美しく彫刻されており、来年も楽しみです。',
  testimonials_customer_15_date: '2025-03-10',
  testimonials_customer_15_reply: '斎藤様、地域イベントの記念品としてお選びいただきありがとうございます。桜祭りが毎年素敵な思い出になりますよう願っております。（長谷川）',
  testimonials_customer_14_name: '林様',
  testimonials_customer_14_age: '30代',
  testimonials_customer_14_gender: '男性',
  testimonials_customer_14_location: '石川県',
  testimonials_customer_14_product: 'サーカス団記念プレート',
  testimonials_customer_14_comment: 'サーカス団の公演成功記念に作成していただきました。団体名と公演日が刻まれており、団員みんなで大切にしています。',
  testimonials_customer_14_date: '2025-04-22',
  testimonials_customer_14_reply: '林様、サーカス公演の成功おめでとうございます。団員の皆様の団結と努力を形にできたこと、本当に嬉しく思います。素晴らしいパフォーマンスを続けてください！（山下）',
  testimonials_customer_13_name: '木村様',
  testimonials_customer_13_age: '20代',
  testimonials_customer_13_gender: '女性',
  testimonials_customer_13_location: '岡山県',
  testimonials_customer_13_product: '図書館司書資格記念プレート',
  testimonials_customer_13_comment: '図書館司書の資格取得記念に作成しました。資格名と取得日が美しく刻まれており、とても満足しています。',
  testimonials_customer_13_date: '2025-05-15',
  testimonials_customer_13_reply: '木村様、資格取得おめでとうございます！努力の成果を形にするお手伝いができて光栄です。図書館司書としてのご活躍を心より応援しております。（長谷川）',
  testimonials_customer_12_name: '井上様',
  testimonials_customer_12_age: '60代',
  testimonials_customer_12_gender: '女性',
  testimonials_customer_12_location: '沖縄県',
  testimonials_customer_12_product: '新築祝いプレート',
  testimonials_customer_12_comment: '新築の記念に家族の名前と新築年月日を彫刻していただきました。玄関に飾っており、来客の方にも好評です。',
  testimonials_customer_12_date: '2025-06-28',
  testimonials_customer_12_reply: '井上様、新築おめでとうございます！ご家族の新しい門出を記念するプレートを制作させていただき、本当に嬉しいです。素敵なお家での幸せな日々をお祈りしております。（山下）',
  testimonials_customer_11_name: '松本様',
  testimonials_customer_11_age: '40代',
  testimonials_customer_11_gender: '男性',
  testimonials_customer_11_location: '長野県',
  testimonials_customer_11_product: '車購入記念プレート',
  testimonials_customer_11_comment: '念願のマイカー購入記念に作成しました。車種と購入日が刻まれており、ガレージに飾っています。',
  testimonials_customer_11_date: '2025-07-18',
  testimonials_customer_11_reply: '松本様、念願のマイカー購入おめでとうございます！大切な愛車と共に、素敵なドライブライフをお楽しみください。（長谷川）',
  testimonials_customer_10_name: '加藤様',
  testimonials_customer_10_age: '50代',
  testimonials_customer_10_gender: '女性',
  testimonials_customer_10_location: '京都府',
  testimonials_customer_10_product: 'カフェ開店記念プレート',
  testimonials_customer_10_comment: 'カフェの開店記念に店名と開店日を彫刻していただきました。お店の入り口に飾っており、お客様からも「素敵ですね」と言われます。',
  testimonials_customer_10_date: '2025-07-30',
  testimonials_customer_10_reply: '加藤様、カフェ開店おめでとうございます！お客様にも好評とのこと、とても嬉しく思います。カフェの益々のご繁盛をお祈りしております。（山下）',
  testimonials_customer_9_name: '小林様',
  testimonials_customer_9_age: '30代',
  testimonials_customer_9_gender: '女性',
  testimonials_customer_9_location: '広島県',
  testimonials_customer_9_product: '音楽発表会記念プレート',
  testimonials_customer_9_comment: '娘のピアノ発表会の記念に作成しました。曲名と日付が美しく彫刻されており、娘も大変喜んでいます。',
  testimonials_customer_9_date: '2025-08-12',
  testimonials_customer_9_reply: '小林様、お嬢様の発表会成功おめでとうございます。音楽への想いを形にしたプレートを喜んでいただけて光栄です。これからも素敵な演奏を続けてください！（長谷川）',
  testimonials_customer_8_name: '中村様',
  testimonials_customer_8_age: '20代',
  testimonials_customer_8_gender: '男性',
  testimonials_customer_8_location: '静岡県',
  testimonials_customer_8_product: 'サッカーチーム記念プレート',
  testimonials_customer_8_comment: 'サッカーチームの優勝記念に作成していただきました。チーム名と優勝年度が刻まれており、チームメンバー全員で大切にしています。',
  testimonials_customer_8_date: '2025-08-25',
  testimonials_customer_8_reply: '中村様、優勝おめでとうございます！チームの皆様の団結と努力を形にできたこと、本当に嬉しいです。今後の試合でもご活躍を期待しております！（山下）',
  testimonials_customer_7_name: '渡辺様',
  testimonials_customer_7_age: '40代',
  testimonials_customer_7_gender: '女性',
  testimonials_customer_7_location: '宮城県',
  testimonials_customer_7_product: 'カスタム名刺',
  testimonials_customer_7_comment: 'デザイナーとして個性的な名刺が欲しく注文しました。オリジナルデザインを美しく彫刻していただき、クライアントからの評判も上々です。',
  testimonials_customer_7_date: '2025-09-10',
  testimonials_customer_7_reply: '渡辺様、クライアント様からも好評とのこと、とても嬉しく思います。デザイナーとしてのご活躍を心より応援しております！（長谷川）',
  testimonials_customer_6_name: '伊藤様',
  testimonials_customer_6_age: '30代',
  testimonials_customer_6_gender: '男性',
  testimonials_customer_6_location: '北海道',
  testimonials_customer_6_product: '会社設立記念プレート',
  testimonials_customer_6_comment: '起業記念として会社名と設立日を彫刻していただきました。オフィスの受付に飾っており、来客の方にも好評です。',
  testimonials_customer_6_date: '2025-09-22',
  testimonials_customer_6_reply: '伊藤様、起業おめでとうございます！会社の門出を記念するプレートを制作させていただき光栄です。事業の益々のご発展をお祈りしております。（山下）',
  testimonials_customer_5_name: '高橋様',
  testimonials_customer_5_age: '60代',
  testimonials_customer_5_gender: '男性',
  testimonials_customer_5_location: '福岡県',
  testimonials_customer_5_product: '還暦祝いプレート',
  testimonials_customer_5_comment: '還暦のお祝いに家族からプレゼントしてもらいました。自分の名前と生年月日が美しく刻まれており、感動しました。',
  testimonials_customer_5_date: '2025-10-03',
  testimonials_customer_5_reply: '高橋様、還暦おめでとうございます。ご家族からの愛情のこもったプレゼントを形にするお手伝いができ、とても嬉しく思います。これからもお元気でお過ごしください。（長谷川）',
  testimonials_customer_4_name: '鈴木様',
  testimonials_customer_4_age: '50代',
  testimonials_customer_4_gender: '女性',
  testimonials_customer_4_location: '神奈川県',
  testimonials_customer_4_product: '退職記念プレート',
  testimonials_customer_4_comment: '長年勤めた会社を退職する際の記念品として注文しました。同僚からも「素敵ですね」と言われ、とても満足しています。',
  testimonials_customer_4_date: '2025-10-15',
  testimonials_customer_4_reply: '鈴木様、長年のお勤めお疲れ様でした。人生の大切な節目を記念するプレートを制作させていただき光栄です。新しい人生のステージでのご活躍をお祈りしております。（山下）',
  testimonials_customer_3_name: '山田様',
  testimonials_customer_3_age: '20代',
  testimonials_customer_3_gender: '男性',
  testimonials_customer_3_location: '愛知県',
  testimonials_customer_3_product: '大学合格記念プレート',
  testimonials_customer_3_comment: '息子の大学合格記念に作成していただきました。大学名と合格日を美しく彫刻していただき、家族みんなで喜んでいます。',
  testimonials_customer_3_date: '2025-10-28',
  testimonials_customer_3_reply: '山田様、息子様の大学合格おめでとうございます！ご家族の喜びを形にできたこと、制作者として本当に嬉しいです。息子様の今後のご活躍を心よりお祈りしております。（長谷川）',
  testimonials_customer_2_name: '佐藤様',
  testimonials_customer_2_age: '40代',
  testimonials_customer_2_gender: '男性',
  testimonials_customer_2_location: '大阪府',
  testimonials_customer_2_product: 'ステンレス名刺',
  testimonials_customer_2_comment: '営業職として他社との差別化を図りたく注文しました。お客様との商談で必ず話題になり、印象に残ってもらえています。投資以上の価値がありました。',
  testimonials_customer_2_date: '2025-11-08',
  testimonials_customer_2_reply: '佐藤様、営業活動でお役に立てているとのこと、とても嬉しいです。ビジネスシーンでの印象づくりに貢献でき光栄です。今後も益々のご活躍を応援しております！（山下）',
  testimonials_customer_1_name: '田中様',
  testimonials_customer_1_age: '30代',
  testimonials_customer_1_gender: '女性',
  testimonials_customer_1_location: '東京都',
  testimonials_customer_1_product: '結婚記念プレート',
  testimonials_customer_1_comment: '結婚10周年の記念に夫婦の名前と記念日を彫刻していただきました。ステンレスの質感が高級感があり、リビングに飾っています。一生の宝物になりました。',
  testimonials_customer_1_date: '2025-11-15',
  testimonials_customer_1_reply: '田中様、結婚10周年おめでとうございます。お二人の大切な記念日を形にするお手伝いができ、本当に嬉しいです。これからも末永くお幸せに。（長谷川）',

  // FAQ Page
  faq_title: 'よくある質問',
  faq_subtitle: 'お客様からよくいただくご質問にお答えします',
  faq_category_pricing: '料金について',
  faq_category_delivery: '納期・配送について',
  faq_category_design: 'デザインについて',
  faq_category_materials: '素材について',
  faq_category_other: 'その他',
  faq_breadcrumb_home: 'ホーム',
  faq_hero_title: 'よくある質問',
  faq_hero_subtitle: 'NEXUTHA名古屋',
  faq_hero_description: 'お客様からよくいただくご質問にお答えします',
  faq_contact_box_title: 'お気軽にご相談ください',
  faq_contact_box_desc: 'こちらに掲載されていないご質問は、お気軽にお問い合わせください。',
  faq_contact_button: 'お問い合わせ',
  faq_estimate_button: '見積もり依頼',
  faq_notice_title: 'ご来訪の方へのお願い',
  faq_notice_subtitle: '持ち込み彫刻をご検討の方へ',
  faq_notice_intro1: 'NEXUTHAは名古屋市港区の小さな個人工房で、一つひとつ手作業で制作しています。大型工場とは異なる環境ですが、丁寧な仕上がりを大切にしています。',
  faq_notice_intro2: '持ち込みでの彫刻も承っておりますが、ご来訪の際は以下の点をご確認ください。',
  faq_notice_parking_title: '駐車場について',
  faq_notice_parking_desc: '専用駐車場はございません。近隣のコインパーキングをご利用いただくか、工房前に短時間停車していただく形になります。',
  faq_notice_road_title: '工房周辺の道路について',
  faq_notice_road_desc: '工房前の道路は比較的広め（片側1車線程度）ですが、長時間の駐車はご近所の迷惑になる場合があります。お品物の受け渡しなど短時間の停車はご対応可能です。',
  faq_notice_reservation_title: '事前予約が必要です',
  faq_notice_reservation_desc: '制作に集中した小さな工房のため、飛び込みでのご来訪はお受けできません。LINEまたはお問い合わせフォームにてご連絡の上、ご来訪ください。',
  faq_notice_footer: 'ご理解とご協力のほど、よろしくお願いいたします。',
  faq_cta_title: 'まだご質問がありますか？',
  faq_cta_desc: 'お気軽にお問い合わせください。専門スタッフが丁寧にお答えします。',
  faq_cta_contact: 'お問い合わせ',
  faq_cta_estimate: '見積もり依頼',
  faq_cat_pricing: '料金について',
  faq_cat_delivery: '納期・配送について',
  faq_cat_design: 'デザイン・制作について',
  faq_cat_materials: '素材・仕様について',
  faq_cat_other: 'その他',
  faq_q_price: '料金はどのくらいかかりますか？',
  faq_a_price: 'ステンレス名刺は1枚500円から、記念プレートは3,000円からとなります。ホームページからのご注文で10%割引が適用されます。詳細は料金シミュレーターをご利用ください。',
  faq_q_quote_free: '見積もりは無料ですか？',
  faq_a_quote_free: 'はい、お見積もりは完全無料です。ホームページのフォームまたはお電話でお気軽にお問い合わせください。見積書の作成も承っております。',
  faq_q_payment: '支払い方法は何がありますか？',
  faq_a_payment: '銀行振込でのお支払いとなります。ご入金確認後、制作を開始させていただきます。',
  faq_q_cancel: 'キャンセル料はかかりますか？',
  faq_a_cancel: '制作開始前のキャンセルは無料です。制作開始後は進捗状況によってキャンセル料が発生する場合があります。',
  faq_q_delivery_time: '納期はどのくらいですか？',
  faq_a_delivery_time: '通常5〜7営業日でお届けします。お急ぎの場合は3日以内の特急対応も可能です（+2,000円）。',
  faq_q_shipping_fee: '配送料はかかりますか？',
  faq_a_shipping_fee: '配送先によって適正価格にてお調べしてご案内いたします。お見積もり時に配送料も含めた総額をご提示いたします。',
  faq_q_shipping_method: '配送方法は選べますか？',
  faq_a_shipping_method: 'ヤマト運輸にて発送いたします。時間指定配送も可能です。大切なお品物として丁寧に梱包してお届けします。',
  faq_q_overseas: '海外への発送はできますか？',
  faq_a_overseas: '現在は国内のみの発送となっております。',
  faq_q_revision: 'デザインの修正は可能ですか？',
  faq_a_revision: '初回デザイン提案後、2回まで無料で修正いたします。3回目以降は1回につき1,000円の修正料が発生します。',
  faq_q_any_design: 'どんなデザインでも対応できますか？',
  faq_a_any_design: '写真・ロゴ・文字・イラストなど幅広く対応可能です。ただし著作権に関わるデザインはお受けできない場合があります。',
  faq_q_file_format: 'データの形式は何が使えますか？',
  faq_a_file_format: 'AI・EPS・PDF・JPEGなどに対応しています。手書きのスケッチからデザインを起こすことも可能です。',
  faq_q_text_size: '文字の最小サイズはどのくらいですか？',
  faq_a_text_size: '約1mmまで彫刻可能ですが、読みやすさを考慮すると2mm以上を推奨しています。',
  faq_q_material: 'どんな素材を使っていますか？',
  faq_a_material: '高品質なステンレス（SUS304）を使用しています。錆びにくく、長期間美しさを保ちます。',
  faq_q_size_limit: 'サイズの制限はありますか？',
  faq_a_size_limit: '最大22cm×22cmまで制作可能です。厚みは通常1〜2mmとなります。',
  faq_q_color: 'カラーの追加はできますか？',
  faq_a_color: '現在はカラーリングには対応しておりません。ステンレス素材そのままの仕上がりでご提供しています。',
  faq_q_durability: '製品の耐久性はどのくらいですか？',
  faq_a_durability: 'ステンレス製品は半永久的な耐久性があります。通常の使用では変色・劣化はほとんどありません。',
  faq_q_sample: '注文前にサンプルを見ることはできますか？',
  faq_a_sample: 'サンプルの郵送は行っておりませんが、ギャラリーページで過去の制作実績をご覧いただけます。',
  faq_q_corporate: '法人からの注文は受け付けていますか？',
  faq_a_corporate: 'はい、法人様からのご注文も承っております。個人のお客様と同様に、お気軽にご相談ください。見積書の発行も対応可能です。',
  faq_q_after_service: 'アフターサービスはありますか？',
  faq_a_after_service: '納品後1年以内の不具合・破損については、無償で修理または交換対応いたします。',
  faq_q_privacy: '個人情報の取り扱いはどうなっていますか？',
  faq_a_privacy: 'お客様の情報は厳重に管理し、制作以外の目的には使用いたしません。詳細はプライバシーポリシーをご覧ください。',
  faq_q_photos_limited: 'ポートフォリオの作品写真が少ないのはなぜですか？',
  faq_a_photos_limited: 'NEXUTHAでは、お客様の大切な思い出を一つひとつ丁寧に刻んでいます。多くの作品は個人のご注文に基づくオリジナルオーダーメイドのため、著作権等の関係で実際の完成写真を全て公開することは叶っておりません。掲載されている画像は、ご協力いただいたお客様の作品と、イメージ参考画像を含みます。あなただけの特別な作品を、ぜひご自身の手で体験してください。',
  faq_q_bulk_order: '大量注文は対応可能ですか？',
  faq_a_bulk_order: '場合により承っております。まずはお気軽にご相談ください。納期やご予算に応じて、最適なご提案をさせていただきます。',
  faq_q_wrapping: 'ラッピングは対応していますか？',
  faq_a_wrapping: '現在、ラッピングサービスは行っておりません。簡易ラッピングについてはご相談に応じる場合がございますので、お気軽にお問い合わせください。',
  faq_q_extra_process: '刻印以外の工程（塗装・下地処理など）も依頼できますか？',
  faq_a_extra_process: '基本的にデータ作成〜レーザー彫刻までを一貫して行っており、塗装や下地処理等の追加工程は原則お断りさせていただいております。ただし、内容により挑戦させていただく場合もございますので、まずはお気軽にご相談ください。',

  // Process Page
  process_page_title: '制作の流れ',
  process_page_subtitle: '5つのステップで理想の作品を実現',
  process_quality_title: '品質へのこだわり',
  process_quality_subtitle: '妥協のない品質管理',
  process_express_title: '特急対応サービス',
  process_express_subtitle: 'お急ぎの場合も安心',

  // Common
  free_consultation: '無料相談',
  years: '年',
  projects_count: 'プロジェクト',
  percent: '%',
  view_all_testimonials: 'すべてのお客様の声を見る',

  // Header
  nav_simulator: 'シミュレーター',
  nav_studio: '工房紹介',
  nav_blog: 'ブログ',
  nav_column: 'コラム',

  // Studio / Workshop page
  studio_about_badge: 'NEXUTHAについて',
  studio_hero_title: '工房紹介',
  studio_hero_subtitle: 'AI×最新技術 — 規格外の工房',
  studio_hero_subtitle2: 'NEXUTHA',
  studio_hero_desc: 'NEXUTHAは、AI技術と最新レーザー彫刻を融合させた全く新しいスタイルの工房です。',
  studio_story_badge: '私たちのストーリー',
  studio_story_title: 'AI×最新技術で、',
  studio_story_title2: '既存の工房とは規格外の存在へ',
  studio_story_p1: 'NEXUTHAは名古屋を拠点に、夫婦二人で運営するレーザー彫刻工房です。他の工房と一線を画すのは、AI技術を積極的に取り入れていること。',
  studio_story_p2: 'デザインのイメージ画像生成から素材選定、工数計算まで、あらゆる工程でAIの専門知識を活用することで、従来の工房では実現できなかったスピードと精度を実現しています。',
  studio_story_p3: 'AIに抵抗があったお客様も、実際に体験すると「こんなことができるの！」「AIと一緒に作るのが楽しい！」とおっしゃっていただけることが多いです。ぜひ、AI×最新技術が融合した新しい創造体験をお試しください。',
  studio_name_origin_badge: '名前の由来',
  studio_name_origin_title: 'NEXUTHAとは？',
  studio_name_origin_reading: '読み方：ネクスス',
  studio_name_origin_desc: '「NEXUTHA（ネクスス）」は\n**NEXT（次へ）× US（私たち）× ANSWER（答え）**\nを組み合わせた造語です。\n\n「私たちが次の答えを導く」——\nお客様の想いに寄り添い、AIと職人技で\n新しい可能性を切り拓くという意志を、\nこの名前に込めています。',
  studio_name_origin_meaning1_title: 'NEXT',
  studio_name_origin_meaning1_desc: '常に時代の一歩先へ。AI×最新技術で、既存の工房の枠を超えた新しい価値を創造します。',
  studio_name_origin_meaning2_title: 'US',
  studio_name_origin_meaning2_desc: '作り手と受け手が共に創る。お客様と私たちが一緒に答えを見つけていくプロセスを大切にしています。',
  studio_name_origin_meaning3_title: 'ANSWER',
  studio_name_origin_meaning3_desc: 'お客様の「こんなものが欲しい」という想いに、最高の答えを届けること。それがNEXUTHAの使命です。',
  studio_stat_works: '制作実績',
  studio_stat_satisfaction: 'お客様満足度',
  studio_stat_style: '独自スタイル',
  studio_ai_badge_title: 'AI×最新技術',
  studio_ai_badge_sub: '規格外の工房',
  studio_craftsmen_badge: '職人紹介',
  studio_craftsmen_title: '制作者を紹介します',
  studio_craftsmen_subtitle: 'AIと職人技を融合させる二人のクリエイター',
  studio_craftsman1_name: '山下 泰秀',
  studio_craftsman1_role: 'レーザー彫刻職人 / デザイナー',
  studio_craftsman1_bio: 'AI技術を積極的に取り入れ、デザインのイメージ画像生成・素材選定・工数計算に専門知識を活用。Xtool F1 UltraとProcreateを組み合わせ、従来の工房では実現できない精度とスピードで唯一無二の作品を生み出す。',
  studio_craftsman1_spec1: 'レーザー彫刻',
  studio_craftsman1_spec2: 'AIデザイン',
  studio_craftsman1_spec3: 'ステンレス加工',
  studio_craftsman2_name: '山下 琉和',
  studio_craftsman2_role: 'レーザー彫刻職人 / カスタマーサポート',
  studio_craftsman2_bio: 'お客様とのコミュニケーションを大切にし、AIによるイメージ提案でご要望を正確に形にする。「AIってすごい！」と感動していただける新しい体験を、一つひとつの作品に込めている。',
  studio_craftsman2_spec1: '金属加工',
  studio_craftsman2_spec2: 'AIプロポーザル',
  studio_craftsman2_spec3: '品質管理',
  studio_values_badge: '私たちのこだわり',
  studio_values_title: 'NEXUTHAのこだわり',
  studio_value1_title: 'AI×職人技の融合',
  studio_value1_desc: 'デザイン生成・素材提案・工数計算にAIを取り入れることで、従来の工房では実現できない精度とスピードを実現します。',
  studio_value2_title: '新しい創造体験',
  studio_value2_desc: 'お客様がAIと一緒にビジョンを広げていく新しいプロセス。「こんな仕上がりになるの？」という驚きと喜びをお届けします。',
  studio_value3_title: '妥協なき精度',
  studio_value3_desc: '0.01mmの精度にこだわり、AIが導き出した最適なデザインを美しく仕上げます。',
  studio_value4_title: '永続する品質',
  studio_value4_desc: 'ステンレスをはじめとした高品質素材を使用し、最新技術で生み出した作品は長年にわたって美しさを保ちます。',
  studio_equipment_badge: '使用機材',
  studio_equipment_title: '使用ツール・機材',
  studio_equipment_subtitle: '卓越した仕上がりを可能にする道具たち',
  studio_eq1_name: 'Xtool F1 Ultra',
  studio_eq1_category: 'メインレーザー機',
  studio_eq1_desc: 'トップクラスの精度を誇るプロ仕様レーザー彫刻機。0.01mmの加工が可能で、ステンレス・木材・アクリルなど多様な素材に対応。',
  studio_eq1_spec1: '最大出力: 20W',
  studio_eq1_spec2: '精度: 0.01mm',
  studio_eq1_spec3: '対応素材: 金属・木材・アクリル・革',
  studio_eq2_name: 'Procreate',
  studio_eq2_category: 'デザインツール',
  studio_eq2_desc: 'iPad用プロフェッショナルデジタルイラストアプリ。レーザー彫刻に最適化したオリジナル線画デザインをゼロから制作し、お客様ごとに唯一無二のデザインを実現。',
  studio_eq2_spec1: 'オリジナルイラスト制作',
  studio_eq2_spec2: 'ベクター対応',
  studio_eq2_spec3: '精密な細部デザイン',
  studio_history_badge: '歩み',
  studio_history_title: 'NEXUTHAの歩み',
  studio_milestone1_year: '2023',
  studio_milestone1_event: 'NEXUTHAとして活動開始。Xtool F1 Ultraを導入し、本格的なレーザー彫刻をスタート。',
  studio_milestone2_year: '2024',
  studio_milestone2_event: '累計制作数100点突破。ステンレス名刺・記念プレートが口コミで広がり、全国からご注文をいただく。',
  studio_milestone3_year: '2025',
  studio_milestone3_event: '累計制作数500点超。お客様満足度98%を達成。カスタムオーダーの幅をさらに拡大。',
  studio_milestone4_year: '2026',
  studio_milestone4_event: '真鍮・革など新素材の取り扱いを開始。より多様なご要望に対応できる体制を構築中。',
  studio_cta_title: 'あなたのビジョンを一緒に形にしましょう。',
  studio_cta_desc: 'ご相談・お見積もりは無料です。お気軽にお問い合わせください。',
  studio_cta_consult: '無料相談・お見積もり',
  studio_cta_gallery: '作品を見る',

  // Pricing quantity/size labels (used in simulator)
  pricing_size_namecard: '名刺サイズ（9cm×5.5cm）',
  pricing_qty_1: '1枚',
  pricing_qty_5: '5枚',
  pricing_qty_10: '10枚',
  pricing_qty_20: '20枚',
  pricing_qty_50: '50枚',
  pricing_qty_100: '100枚',
  pricing_faq_badge: 'よくある質問',
  pricing_faq_title: 'よくある質問',
  pricing_faq_subtitle: '料金に関するよくある質問',
  faq_delivery_question_1: '納期はどのくらいですか？',
  faq_delivery_answer_1: '通常5〜7営業日でお届けします。お急ぎの場合は3日以内の特急対応も可能です（+2,000円）。',
  faq_delivery_question_2: '配送料はかかりますか？',
  faq_delivery_answer_2: '配送先によって適正価格にてお調べしてご案内いたします。お見積もり時に配送料も含めた総額をご提示いたします。',
  faq_design_question_1: 'デザインの修正は可能ですか？',
  faq_design_answer_1: '初回デザイン提案後、2回まで無料で修正いたします。3回目以降は1回につき1,000円の修正料が発生します。',
  faq_more_questions: 'その他のご質問はFAQページをご覧ください',
  faq_view_all: 'すべての質問を見る',

  // Pricing section (dot notation keys)
  'pricing.title': '料金プラン',
  'pricing.subtitle': '高品質なステンレス加工を、明確で分かりやすい料金体系でご提供いたします。',
  'pricing.simulator.title': '見積もりシミュレーター',
  'pricing.simulator.product_type': '商品タイプを選択',
  'pricing.simulator.namecard.title': 'ステンレス名刺',
  'pricing.simulator.namecard.description': '高級感のあるステンレス製名刺',
  'pricing.simulator.namecard.price_from': '¥500〜',
  'pricing.simulator.plate.title': '記念プレート',
  'pricing.simulator.plate.description': '特別な記念品として最適',
  'pricing.simulator.plate.price_from': '¥3,000〜',
  'pricing.simulator.size_select': 'サイズを選択',
  'pricing.simulator.quantity_select': '数量を選択',
  'pricing.simulator.pieces': '枚',
  'pricing.simulator.discount_off': 'OFF',
  'pricing.simulator.estimate_result': 'お見積もり結果',
  'pricing.simulator.product_type_label': '商品タイプ:',
  'pricing.simulator.size_label': 'サイズ:',
  'pricing.simulator.quantity_label': '数量:',
  'pricing.simulator.website_discount': 'ホームページ割引 (10%OFF):',
  'pricing.simulator.discount_applied': '適用済み',
  'pricing.simulator.tax_included': '(税込)',
  'pricing.simulator.request_estimate': 'この内容で見積もり依頼',
  'pricing.estimate.title': '見積もり依頼',
  'pricing.estimate.selectedItems': '選択内容',
  'pricing.estimate.productType': '商品タイプ',
  'pricing.estimate.size': 'サイズ',
  'pricing.estimate.quantity': '数量',
  'pricing.estimate.pieces': '枚',
  'pricing.estimate.totalPrice': '合計金額',
  'pricing.estimate.name': 'お名前',
  'pricing.estimate.namePlaceholder': 'お名前を入力してください',
  'pricing.estimate.email': 'メールアドレス',
  'pricing.estimate.emailPlaceholder': 'メールアドレスを入力してください',
  'pricing.estimate.phone': 'お電話番号',
  'pricing.estimate.phonePlaceholder': 'お電話番号を入力してください',
  'pricing.estimate.designRequests': 'デザインのご要望',
  'pricing.estimate.designPlaceholder': 'デザインのご要望やご質問をお聞かせください',
  'pricing.estimate.characters': '文字',
  'pricing.estimate.cancel': 'キャンセル',
  'pricing.estimate.submit': '見積もり依頼を送信',
  'pricing.estimate.success': '見積もり依頼を送信しました。24時間以内にご連絡いたします。',
  'pricing.estimate.error': '送信に失敗しました。再度お試しください。',
  'pricing.estimate.network_error': '送信エラーが発生しました。もう一度お試しください。',
  'pricing.estimate.required_fields': 'お名前とメールアドレスは必須項目です。',
  'pricing.namecard.title': 'ステンレス名刺',
  'pricing.namecard.feature1': '高級ステンレス素材',
  'pricing.namecard.feature2': 'レーザー彫刻加工',
  'pricing.namecard.feature3': '耐久性抜群',
  'pricing.plate.title': '記念プレート',
  'pricing.plate.feature1': 'カスタムデザイン対応',
  'pricing.plate.feature2': '記念品に最適',
  'pricing.plate.feature3': '永続的な品質',
};
